import React from 'react';
import moment from 'moment/moment';

export default function CardRelatorio({ headers = [], items = [] }) {
    return (
        <div className='ps-2 w-100'>
            {items.map((value, index) => {
                return (
                    <>
                        <div style={{ background: index % 2 == 0 ? "white" : "#c9c9c9" }} 
                        className='contentGroup w-100 row border-bottom'
                        >
                            {headers.map(valor => {
                                if (valor.objectValue.length > 0 && typeof valor.objectValue == "object") {
                                    let novoValor = "";
                                    valor.objectValue.map((objectValue, index) => {
                                        if (value[objectValue]) {
                                            novoValor += index > 0 ? valor.separator + value[objectValue] : value[objectValue]
                                        }
                                    });
                                    value[valor.objectValue] = novoValor;
                                }
                                if (!valor.title) {
                                    return (
                                        <div className={`col-${valor.col}`}>
                                            <p><span className="fw-bold">{valor.value ? `${valor.value}:` : ""} </span>
                                                {valor.prefix && value[valor.objectValue] != "Sem informação" ? valor.prefix : ""}
                                                {valor.formatDate && value[valor.objectValue] &&
                                                    value[valor.objectValue] != "Sem informação" &&
                                                    moment(value[valor.objectValue]).format("DD/MM/YYYY HH:mm:ss")
                                                }
                                                {valor.formatDateSemHora && value[valor.objectValue] &&
                                                    value[valor.objectValue] != "Sem informação" &&
                                                    moment(value[valor.objectValue]).format("DD/MM/YYYY")
                                                }
                                                {!valor.formatDate && !valor.formatDateSemHora && value[valor.objectValue] &&
                                                    value[valor.objectValue] != "Sem informação" &&
                                                    value[valor.objectValue]
                                                }
                                                {valor.sufix && value[valor.objectValue] != "Sem informação" ? valor.sufix : ""}
                                            </p>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div className={`col-${valor.col}`}>
                                            <h5 className='m-0 fw-bold'>{valor.value ? valor.value : value[valor.objectValue]}</h5>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </>
                )
            })}
        </div>
    )
}